import React, { useState, useEffect, useRef } from 'react';
import img1 from "./images/custemorImg1.png";
import img2 from "./images/custemorImg2.png";
import img3 from "./images/custemorImg3.png";

const slides = [
    {
        image: img1,
        title: "HealthPlus Transformation",
        desc:
            "HealthPlus revolutionized patient care using our integrated healthcare solutions, improving outcomes and operational efficiency.",
        stats: [
            { k: "90%", v: "Patient Satisfaction" },
            { k: "-30%", v: "Response Time" },
            { k: "$2M", v: "Cost Savings" },
        ],
        cta: "Read the story",
    },
    {
        image: img2,
        title: "RetailGo Omnichannel Lift",
        desc:
            "RetailGo unified chat, order tracking and support to boost conversions and reduce support load during peak seasons.",
        stats: [
            { k: "+22%", v: "Checkout Conversion" },
            { k: "-35%", v: "Support Tickets" },
            { k: "4.8★", v: "CSAT" },
        ],
        cta: "Read the story",
    },
    {
        image: img3,
        title: "FinServe CX Modernization",
        desc:
            "FinServe automated onboarding and servicing on WhatsApp, cutting turnaround time and elevating customer experience.",
        stats: [
            { k: "3×", v: "Faster Onboarding" },
            { k: "-40%", v: "Ops Cost" },
            { k: "NPS 68", v: "Customer Loyalty" },
        ],
        cta: "Read the story",
    },
];

const CustemorSection = () => {
    const [idx, setIdx] = useState(0);
    const wrapRef = useRef(null);

    const next = () => setIdx((p) => (p + 1) % slides.length);
    const prev = () => setIdx((p) => (p - 1 + slides.length) % slides.length);

    useEffect(() => {
        const el = wrapRef.current;
        let t;
        const start = () => (t = setInterval(next, 6000));
        const stop = () => clearInterval(t);
        start();
        el?.addEventListener('mouseenter', stop);
        el?.addEventListener('mouseleave', start);
        return () => {
            stop();
            el?.removeEventListener('mouseenter', stop);
            el?.removeEventListener('mouseleave', start);
        };
    }, []);

    const s = slides[idx];

    return (
        <section className="py-5 position-relative cs-bg" style={{ overflow: 'hidden', marginTop: 80 }}>
            <div className="px-5 x-xxl-5 px-6 mx-auto position-relative" style={{ maxWidth: '74%', zIndex: 1 }}>
                {/* Heading */}
                <div style={{ textAlign: "center" }}>
                    <h2
                        style={{
                            fontSize: '44px',
                            fontFamily: "'Inter', sans-serif",
                            fontWeight: 650,
                            color: '#1C1C1C',
                            lineHeight: 1.2,
                        }}
                    >
                        Customer stories
                    </h2>
                    <p
                        className="mt-2"
                        style={{
                            fontSize: 20,
                            color: "#6B6B6B",
                            fontWeight: 400,
                            fontFamily: "'Inter', sans-serif",
                            lineHeight: 1.2,
                            margin: 0,
                        }}
                    >
                        Real stories from happy clients showcasing trust, success and satisfaction.
                    </p>
                </div>

                {/* Carousel */}
                <div ref={wrapRef} className="cs-wrap">
                    <button className="nav-btn left" onClick={prev} aria-label="Previous">‹</button>

                    <div className="slide">
                        <div className="s-img">
                            <img src={s.image} alt={s.title} loading="lazy" decoding="async" />
                        </div>
                        <div className="s-content">
                            <h3 className="s-title">{s.title}</h3>
                            <p className="s-desc">{s.desc}</p>

                            <div className="s-stats">
                                {s.stats.map((it, i) => (
                                    <div className="stat" key={i}>
                                        <div className="stat-k">{it.k}</div>
                                        <div className="stat-v">{it.v}</div>
                                    </div>
                                ))}
                            </div>

                            <button className="s-cta">{s.cta.toUpperCase()}</button>
                        </div>
                    </div>

                    <button className="nav-btn right" onClick={next} aria-label="Next">›</button>
                </div>

                {/* Dots */}
                <div className="cs-dots">
                    {slides.map((_, i) => (
                        <button
                            key={i}
                            onClick={() => setIdx(i)}
                            aria-label={`Go to slide ${i + 1}`}
                            className={`dot ${i === idx ? 'active' : ''}`}
                        />
                    ))}
                </div>
            </div>

            <style>{`
            .cs-bg {
              background: linear-gradient(180deg,#F7FBFF 0%, #EAF3FF 100%);
            }
    
            .cs-wrap {
              margin-top: 40px;
              position: relative;
              display: grid;
              grid-template-columns: 48px 1fr 48px;
              align-items: center;
              gap: 12px;
            }
    
            .slide {
              display: grid;
              grid-template-columns: 1.15fr 1fr;
              gap: 36px;
              align-items: center;
            }
    
            .s-img img {
              width: 100%;
              height: 370px;
              object-fit: cover;
              border-radius: 12px;
              box-shadow: 0 18px 40px rgba(15,35,90,.12);
              background: #fff;
            }
    
            .s-title {
              font-family: 'Inter', sans-serif;
              font-size: 36px;
              font-weight: 800;
              color:#0f172a;
              margin: 0 0 10px 0;
            }
            .s-desc {
              margin: 0 0 18px 0;
              color:#244160;
            }
    
            .s-stats {
              display: grid;
              grid-template-columns: repeat(3, minmax(0,1fr));
              gap: 16px;
              margin: 12px 0 18px;
            }
            .stat {
              background:#eef3fb;
              border:1px solid #dae1edff;
              border-radius:12px;
              padding:16px 10px;
            }
            .stat-k {
              font-size:20px;
              font-weight:800;
              color:#054E91;
              margin-bottom:4px;
            }
            .stat-v {
              color:#475569;
              font-size:14.5px;
              white-space: nowrap; 
              overflow: hidden; 
              text-overflow: ellipsis; 
            }
    
            .s-cta {
              border: none;
              background:#054E91; 
              color:#fff;
              font-weight:580;
              border-radius:8px;
              padding:12px 16px;
              cursor:pointer;
            }
    
            .nav-btn {
              width: 36px; height: 36px;
              border-radius: 8px;
              border: none; cursor: pointer;
              background:#054E91;  
              color:#fff;
              font-size:20px;
              display:flex; align-items:center; justify-content:center;
            }
    
            .cs-dots {
              display:flex;
              justify-content:center;
              gap:6px; 
              margin-top:28px;
            }
            .dot {
              width:8px; height:8px; border-radius:999px; border:none;
              background:#b6c8e3; cursor:pointer;
              margin: 0; 
            }
            .dot.active {
              background:#0b5fd7;
            }
          `}</style>
        </section>
    );
};
export default CustemorSection